<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { Primitive } from 'reka-ui';
import { computed } from 'vue';
import { cn } from '@/lib/utils';
import { useCommand } from '.';

const props = defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const { filterState, disableFilter } = useCommand();
const isRender = computed(
  () => !disableFilter && !!filterState.search && filterState.filtered.count === 0
);
</script>

<template>
  <Primitive
    v-if="isRender"
    v-bind="delegatedProps"
    :class="cn('tw-py-6 tw-text-center tw-text-sm', props.class)"
  >
    <slot />
  </Primitive>
</template>
